import React, { useState, useContext } from 'react';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import TextInput from '../../../sharedModules/form/components/TextInput';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

const ClientCommentsSection: React.FunctionComponent = () => {
  let { chillerLog, setChillerLog, saveCurrentLogToLocalStorage } = useContext(ChillerLogsContext);

  let [expanded, setExpanded] = useState(true);

  return (
    <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
      <AccordionSummary style={{ background: '#A21C37' }}>
        <h3 style={{ background: '#A21C37', color: '#fff', fontWeight: 700, padding: 5 }}>Client Comments</h3>
      </AccordionSummary>
      <AccordionDetails style={{ margin: 0, padding: 0 }}>
        <Grid item xs={12}>
          <TextInput
            value={chillerLog?.customer_comment}
            valueChanged={(value) => setChillerLog((prevLog) => ({ ...prevLog, customer_comment: value }))}
            label={chillerLog?.customer_comment?.length > 0 ? '' : 'Enter your client comments here...'}
            rows={5}
            multiline
            onBlur={saveCurrentLogToLocalStorage}
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default ClientCommentsSection;
